import { NavLink } from 'react-router-dom';

interface Props {
    text: string;
    href: string;
}

export default function MenuItem({ text, href }: Props) {
    return (
        <li
            className='nav-item text-selected'
            key={new Date().getMilliseconds().toString()}
        >
            <NavLink className='nav-link text-selected' to={href}>
                {text}
            </NavLink>
        </li>
    );
}
